"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var FieldDisplay_1 = require("../../components/FieldDisplay");
var Tree_1 = require("../../components/Tree");
var InsuredValuableItemsTree = /** @class */ (function (_super) {
    __extends(InsuredValuableItemsTree, _super);
    function InsuredValuableItemsTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InsuredValuableItemsTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: this.props.valuableItem.description, "data-visible": true, children: [(0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Category", value: this.props.valuableItem.valuableItemType.text }), (0, jsx_runtime_1.jsx)(FieldDisplay_1.FieldDisplay, { label: "Cover location", value: SupportPortalTemplates_1.SupportPortalTemplates.capitalize(this.props.valuableItem.coverLocation) })] }));
    };
    InsuredValuableItemsTree = __decorate([
        components_1.authorize
    ], InsuredValuableItemsTree);
    return InsuredValuableItemsTree;
}(React.Component));
exports.default = InsuredValuableItemsTree;
//# sourceMappingURL=InsuredValuableItemsTree.js.map